import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HoverboxService } from "app/core/services/hoverbox.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserHelpModesService } from "app/core/services/user-help-modes.service";
import { AsyncPipe, NgIf } from "@angular/common";

interface CursorPosition {
  x: number;
  y: number;
}

@Component({
  selector: "hoverbox",
  templateUrl: "./hoverbox.component.html",
  styleUrls: ["./hoverbox.component.scss"],
  imports: [NgIf, AsyncPipe],
})
export class HoverboxComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  // Show the hoverbox always - even if help mode is deactivated
  @Input()
  public showAlways: boolean = false;
  public toolTipToggleVisible: boolean;

  public windowHeight: number;
  public hoverBoxEnabled: boolean = true;
  public xCorrectionAmount: number = 10;
  public yCorrectionAmount: number = 10;
  public positionCoords: {
    x: number;
    y: number;
  } = {
    x: 0,
    y: 0,
  };

  public toolTipToggleVisible$: Observable<boolean>;

  @ViewChild("hoverboxEl", { static: false })
  public elementView: ElementRef | undefined;

  constructor(
    private hoverboxService: HoverboxService,
    private userHelpModesService: UserHelpModesService,
  ) {}

  @HostListener("window:resize", ["$event"])
  public onResize(event: any): void {
    this.windowHeight = event.target.innerHeight;
  }

  public ngOnInit(): void {
    this.windowHeight = window.innerHeight;
    this.toolTipToggleVisible$ = this.userHelpModesService.isHelpModeActive$;

    this.hoverboxService.cursorPos$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((val: any) => {
        if (this.elementView === undefined) {
          // Will fire once on element show
          this.positionCoords = {
            x: -9999,
            y: -9999,
          };
          setTimeout(() => {
            this.reposition(val);
          });
        }
        this.reposition(val);
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public positionXCorrelation(cursorX: number, isEnoughSpace: boolean): number {
    return isEnoughSpace
      ? cursorX -
          this.elementView!.nativeElement.offsetWidth -
          this.xCorrectionAmount
      : cursorX + this.xCorrectionAmount;
  }

  public calculateYPosition(cursorY: number): number {
    const elementHeight: number = this.elementView!.nativeElement.offsetHeight;
    const isOutOfWindow: boolean =
      cursorY + elementHeight + this.yCorrectionAmount >=
      this.windowHeight - 20;
    return isOutOfWindow
      ? cursorY - elementHeight - this.yCorrectionAmount
      : cursorY + this.yCorrectionAmount;
  }

  private reposition(val: CursorPosition): void {
    if (this.elementView && this.elementView.nativeElement.offsetWidth) {
      this.positionCoords = {
        x: this.positionXCorrelation(
          val.x,
          val.x - this.elementView.nativeElement.offsetWidth > 0,
        ),
        y: this.calculateYPosition(val.y),
      };
    }
  }
}
